var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.99988C4 0.899878 3.1 -0.00012207 2 -0.00012207C0.9 -0.00012207 0 0.899878 0 1.99988C0 3.09988 0.9 3.99988 2 3.99988C3.1 3.99988 4 3.09988 4 1.99988ZM6 1.99988C6 3.09988 6.9 3.99988 8 3.99988C9.1 3.99988 10 3.09988 10 1.99988C10 0.899878 9.1 -0.00012207 8 -0.00012207C6.9 -0.00012207 6 0.899878 6 1.99988ZM12 1.99988C12 3.09988 12.9 3.99988 14 3.99988C15.1 3.99988 16 3.09988 16 1.99988C16 0.899878 15.1 -0.00012207 14 -0.00012207C12.9 -0.00012207 12 0.899878 12 1.99988Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsIcon);
export default __webpack_public_path__ + "static/media/optionsIcon.581e6a75.svg";
export { ForwardRef as ReactComponent };